<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @reset="$gjReset"
            @query="$gjNoticeQuery">
          <gj-warehouse-select
              v-model="filter.warehouseIds"
              placeholder="仓库"
              width="180px"
              multiple
          ></gj-warehouse-select>
          <gj-select
              v-model="filter.type"
              :options="WarehouseEum.typeOption"
              width="80px"
              placeholder="类型"
          ></gj-select>
          <gj-select
              v-model="filter.currency"
              :options="[
                {id: 'CNY', text: 'CNY'},
                {id: 'USD', text: 'USD'},
              ]"
              width="80px"
              placeholder="币种"
          ></gj-select>
          <template #right>
            <gj-tool-group
                :download="$permission('warehouseInventory:export')" download-url="/supply/warehouseInventory/exportWarehouseInventory" :download-params="globalParams"
                setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
                help
            ></gj-tool-group>
            <view-setting
                    :ref="REF_VIEW_SETTING"
                    save-mode="remote"
                    :use-default="true"
                    :module-name="moduleName"
                    :config="model"
                    @view-change="handleChangeView"
                    @view-complete="handCompleteView"
            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :name="tableName"
            :data="tableData"
            :columns="columns"
            :pagination="pagination"
            :loading="loading"
            show-summary
            :summary-object="summaryObject"
            :default-sort = "{prop: 'fulfillableQuantity', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:totalAmount="{ row }">
            <gj-popover-panel
                :title="'总货值 = 可售货值 + 不可售货值 + 在途货值'"
                width="100%"
                :data="[
                  {label: '可售货值', value: row.fulfillableAmount},
                  {label: '不可售货值', value: row.unsellableAmount},
                  {label: '在途货值', value: row.transitPrice},
                ]">
              {{row.totalAmount | defaultShow}}
            </gj-popover-panel>
          </template>
          <template v-slot:unsalableQuantity="{ row }">
            <template v-if="row.unsalableQuantity !== 0">
              <gj-popover-panel
                  :title="'滞销详情'"
                  :width="'180px'"
                  :data="buildUnsalable(row.unsalableDetailsList)">
                {{row.unsalableQuantity}}
              </gj-popover-panel>
            </template>
            <template v-else>{{row.unsalableQuantity | defaultShow}}</template>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import {queryMixin} from "../../../../minxins";
  import {exportWarehouseInventory, getWarehouseInventory} from "../../../../api/warehouse";
  import {defaultVal, isMeaningless} from "../../../../utils/common";
  import {WarehouseEum} from "../enum";

  import viewConfig from './viewConfig'

  export default {
    name: "app-warehouse-inventory",
    mixins: [queryMixin],
    created() {
      this.sort.prop = 'fulfillableQuantity'
    },
    data() {
      return {
        tableName: 'warehouseInventory',
        tableData: [],
        columns: [
          {id: 'warehouseName', header: '仓库名称', field: 'warehouseName', minWidth: '200px', sortable: true, default: true, fixed: 'left', disabled: true},
          {id: 'warehouseType', header: '类型', field: 'option:warehouseType', options: WarehouseEum.typeOption, minWidth: '200px', default: true},
          {id: 'skuSpecies', header: '产品种类', field: 'skuSpecies', minWidth: '90px', sortable: true, align: 'right', default: true},
          {id: 'fbmFulfillableQuantity', header: 'FBM可售', summary: true, help: 'mfn-fulfillable-quantity', field: 'fbmFulfillableQuantity', minWidth: '110px', sortable: true, align: 'right', default: true},
         {id: 'fulfillableQuantity', header: 'FBA可售', summary: true, helpHtml: '自营仓：此仓库下所有良品量总和<br/>FBA仓：afn-unsellable-quantity',field: 'fulfillableQuantity', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'reservedQuantity', header: '预留', summary: true, help: 'afn-reserved-quantity', field: 'reservedQuantity', minWidth: '80px', sortable: true, align: 'right', default: true},
          {id: 'unsellableQuantity', header: '不可售', summary: true,  helpHtml:'自营仓：此仓库下所有次品量总和<br/>FBA仓：afn-unsellable-quantity', field: 'unsellableQuantity', minWidth: '95px', sortable: true, align: 'right', default: true},
          {id: 'saleableTurnover', header: '可售周转', summary: true, help: '可售 / 7天日均', field: 'saleableTurnover', minWidth: '120px', sortable: true, align: 'right'},
          {id: 'fulfillableAmount', header: '可售货值', summary: true, permission: 'cost:view', help: '可售 * (采购成本 + 到库成本)', field: 'fulfillableAmount', minWidth: '120px', sortable: true, align: 'right', default: true},
          {id: 'unsellableAmount', header: '不可售货值', summary: true, permission: 'cost:view', help: '不可售 * (采购成本 + 到库成本)', field: 'unsellableAmount', minWidth: '130px', sortable: true, align: 'right', default: true},
          {id: 'transitQuantity', header: '在途量', summary: true, help: '发货单处于已出运的发货量；发货单处于收货的发货量-收货量', field: 'transitQuantity', minWidth: '100px', sortable: true, align: 'right', default: true},
          {id: 'transitPrice', header: '在途货值', summary: true, permission: 'cost:view', help: '在途量 *（采购成本 + 到库成本）', field: 'transitPrice', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'totalAmount', header: '总货值', summary: true, permission: 'cost:view', help: '可售货值 + 不可售货值 + 在途货值', field: 'slot:totalAmount', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'invAge0To30Days', header: '0-30天库龄', summary: true, field: 'invAge0To30Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          {id: 'invAge31To60Days', header: '31-60天库龄', summary: true, field: 'invAge31To60Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          {id: 'invAge61To90Days', header: '61-90天库龄', summary: true, field: 'invAge61To90Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          // {id: 'invAge0To90Days', header: '0-90天库龄', summary: true, field: 'invAge0To90Days', minWidth: '120px', align: 'right', sortable: true},
          {id: 'invAge91To180Days', header: '91-180天库龄', summary: true, field: 'invAge91To180Days', minWidth: '130px', align: 'right', sortable: true},
          {id: 'invAge181To270Days', header: '181-270天库龄', summary: true, field: 'invAge181To270Days', minWidth: '135px', align: 'right', sortable: true},
          {id: 'invAge271To365Days', header: '271-365天库龄', summary: true, field: 'invAge271To365Days', minWidth: '135px', align: 'right', sortable: true},
          {id: 'invAge365PlusDays', header: '365天以上库龄', summary: true, field: 'invAge365PlusDays', minWidth: '125px', align: 'right', sortable: true},
          {id: 'unsalableQuantity', header: '滞销', summary: true, help: '根据用户设置滞销天数多少计算滞销', field: 'slot:unsalableQuantity', minWidth: '90px', align: 'right', default: true},
          {id: 'unsalableRate', header: '滞销率', summary: true, help: '(滞销 / 在库) * 100%', field: 'unsalableRate', minWidth: '90px', align: 'right', suffix: '%'},
          {id: 'unsalableAmount', header: '滞销货值', summary: true, permission: 'cost:view', help: '滞销 * (采购成本 + 到库成本)', field: 'unsalableAmount', minWidth: '100px', align: 'right', default: true},
        ],
        filter: {
          warehouseIds: [],
          currency: 'CNY',
          type: null,
        },
        WarehouseEum,
        moduleName: 'WAREHOUSE_INVENTORY',
        model: viewConfig,
        summaryObject: null,
      }
    },
    methods: {
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        this.filter = Object.assign({}, this.filter, {
          ...params,
        })
      },
      $gjQuery() {
        this.loading = true;
        let params = {
          model: {
            warehouseIds: isMeaningless(this.filter.warehouseIds) ? [] : this.filter.warehouseIds,
            warehouseType: defaultVal(this.filter.type, null),
            currency: this.filter.currency,
          },
          ...this.queryPagination,
          ...this.querySort,
        }
        this.globalParams = params
        getWarehouseInventory(params).then((data) => {
          this.tableData = data.records;
          this.summaryObject = data.statisticRecord;
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: [],
            currency: 'CNY',
            type: null
          }
        }
      },
      exportData() {
        exportWarehouseInventory(this.globalParams);
      },
      buildUnsalable(item) {
        return (item || []).map(v => {
          return {label: v.ageRange, value: v.quantity};
        })
      }
    }
  }
</script>

<style scoped>

</style>
